module.exports = __webpack_public_path__ + "img/Saint Martin.36b5c39b.svg";